import { createSlice } from '@reduxjs/toolkit';

import { isInGame } from '~/constants';
import { POSHTA_MARKER_STATUS, type PoshtaMarker } from '~/types/poshta';
import { sendPoshtaMarkers } from '~/web2ClientAPI/base';

import type { PayloadAction } from '@reduxjs/toolkit';

interface PoshtaState {
  isReady: boolean;
  markers: PoshtaMarker[];
}

const initialState: PoshtaState = {
  isReady: false,
  markers: [],
};

const poshtaSlice = createSlice({
  name: 'poshta',
  initialState,
  reducers: {
    setMarkers: (state: PoshtaState, action: PayloadAction<PoshtaMarker[]>) => {
      state.markers = action.payload;
      state.isReady = true;
    },

    deactivateMarkers: (state: PoshtaState, action: PayloadAction<string[]>) => {
      if (!state.isReady) {
        return;
      }

      const idsToDeactivate = new Set(action.payload);

      state.markers.forEach((marker) => {
        if (idsToDeactivate.has(marker.id)) {
          marker.status = POSHTA_MARKER_STATUS.INACTIVE;
        }
      });
    },

    syncMarkersToClient: (state: PoshtaState) => {
      if (!isInGame) {
        return;
      }

      sendPoshtaMarkers(state.markers);
    },
  },
});

export const poshtaActions = poshtaSlice.actions;

export default poshtaSlice.reducer;
